import styled from 'styled-components'
import { colors } from '../../theme'

export const ContainerModalSend = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 1.5%;
  background-color: ${colors.overlay};
  display: block;
  z-index: 2001;
`

export const SendStyle = styled.div`
  width: 770px;
  background-color: ${colors.surface};
  border-radius: 26px 26px 24px 24px;
  margin: 0 auto;
  text-align: center;
  height: 590px;
`
export const DivImg = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 24px 24px 0 0;
  padding: 30px 30px 10px 30px;
`
export const ContainerCards = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  width: 100%;
  padding: 35px 20px 20px 20px;
  text-align: left;
`
export const ContainerTable = styled.div`
  width: 100%;
  padding: 0 30px;
  text-align: left;
`

export const Table = styled.table<{ size?: string }>`
  margin-top: 20px;
  text-align: center;
  background-color: ${colors.grey50};
  color: ${colors.primaryText};
  font-weight: 500;
  position: relative;
  border: 0;
  padding: 0;
  border-spacing: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
  white-space: normal;
  width: 100%;

  tbody > tr:nth-child(odd),
  th > th:nth-child(odd) {
    background-color: ${colors.grey50};
  }
  tr td {
    font-size: 14px;
    padding: 10px 15px;
  }

  td,
  th {
    border-bottom: 3px solid ${colors.surface};
  }
`

export const Thead = styled.thead`
  background: ${colors.grey200};
  color: ${colors.grey700};

  tr,
  th {
    padding: 10px 12px;
    font-size: 11px;
    font-weight: 500;
    border-right: 2px solid ${colors.surface};
    text-align: center;
  }
`
export const Closed = styled.div`
  cursor: pointer;
`
export const CancelarBaixa = styled.button`
  background: ${colors.surface};
  border: solid 1px ${colors.grey300};
  border-radius: 500px;
  padding: 5px 5px 0px 5px;
  cursor: pointer;
`
